import React, { Component, Fragment } from 'react';
import { redirectToPlayerDetails } from '../../../routing/redirectService';
import PlayerIdAndName from '../../../shared/player-id-and-name/PlayerIdAndName';
import FriendlyDate from '../../../shared/FriendlyDate';
import { TimeZoneNote } from '../../../shared/time-zone-note/TimeZoneNote';
import AlertLevel from '../../../shared/alert-level/AlertLevel';
import YesNo from '../../../shared/YesNo';
import * as PropTypes from 'prop-types';
import { default as _, isEmpty } from 'lodash';
import './PlayersList.scss';
import { Pager } from '../../../shared/pager/Pager';
import { EmptyList } from '../../../shared/empty-list/EmptyList';
import { Sorter } from '../../../shared/table/Sorter';
import { players_headers } from './player-headers';
import { TableSearch } from '../../../shared/table-search/TableSearch';
import { Filters } from '../../../shared/filters/Filters';
import {
    extendWithModalSupport,
    ModalContainer
} from '../../../shared/modal-container/ModalContainer';
import { FilterBadgeContainer } from '../../../shared/filter-badge-container/FilterBadgeContainer';
import { FilterButton } from '../../../shared/button/filter-button/FilterButton';
import { SpinLoader } from '../../../shared/spin-loader/SpinLoader';
import TransparentButton from '../../../shared/button/transparent-button/TransparentButton';

const playerListColSpan = 9;

// todo:
// - navigate to last page not working
// - risk was broken

export class PlayersList extends Component {
    static propTypes = {
        data: PropTypes.array,
        loading: PropTypes.bool
    };

    constructor(props) {
        super(props);
        extendWithModalSupport(this);
        this.handleSort = this.handleSort.bind(this);
    }

    onClickViewProfile = (playerId, subtitle) => {
        redirectToPlayerDetails(playerId, subtitle);
    };

    handleSort = ({ sortingKey, sortDirection }) => {
        _.isFunction(this.props.onSortUpdated) &&
            this.props.onSortUpdated({ sortingKey, sortDirection });
    };

    makeFilters = () => {
        const {
            typeConfig,
            severityConfig,
            statusConfig
        } = this.props.filtersConfig;

        return (
            <Filters
                typeConfig={typeConfig}
                severityConfig={severityConfig}
                statusConfig={statusConfig}
                applyFilters={this.handleApplyFilters}
                clearFilters={this.handleClearFilters}
            />
        );
    };

    handleApplyFilters = filters => {
        _.isFunction(this.props.applyFilters) &&
            this.props.applyFilters(filters);
        this.modalInstance.closeModal();
    };

    handleClearFilters = filters => {
        _.isFunction(this.props.clearFilters) &&
            this.props.clearFilters(filters);
        this.modalInstance.closeModal();
    };

    handleSearch = username => {
        _.isFunction(this.props.searchByUsername) &&
            this.props.searchByUsername(username);
    };

    handleRemoveFilter = filterValue => {
        // todo: Needs refactoring but works for now
        const { filters } = this.props;

        const filterType = Object.keys(filters).find(key => {
            return filters[key] === filterValue;
        });

        _.isFunction(this.props.removeFilter) &&
            this.props.removeFilter({ ...filters, [filterType]: null });
    };

    makeRows(data) {
        return (
            <Fragment>
                {(data || []).map(p => (
                    <tr key={p.id} className="data">
                        <td>
                            <PlayerIdAndName username={p.username} id={p.id} />
                        </td>
                        <td>
                            <AlertLevel level={p.riskLevel} />
                        </td>
                        <td>
                            <YesNo value={p.basicIdDone} />
                        </td>
                        <td>
                            <YesNo value={p.basicInfoObtained} />
                        </td>
                        <td>
                            <YesNo value={p.pepCheckDone ? p.pep : 'N/A'} />
                        </td>
                        <td>
                            <YesNo
                                value={
                                    p.sanctionScreeningDone
                                        ? p.sanctioned
                                        : 'N/A'
                                }
                            />
                        </td>
                        <td>{p.accumulatedWithdrawals}</td>
                        <td>
                            {p.lastInfoGathering ? (
                                <FriendlyDate timestamp={p.lastInfoGathering} />
                            ) : (
                                'N/A'
                            )}
                        </td>
                        <td>
                            <TransparentButton
                                onClick={() =>
                                    this.onClickViewProfile(p.id, p.username)
                                }
                            >
                                View Profile
                            </TransparentButton>
                        </td>
                    </tr>
                ))}

                {isEmpty(data) && (
                    <tr>
                        <td
                            className={'empty-list'}
                            colSpan={players_headers.length}
                        >
                            <EmptyList />
                        </td>
                    </tr>
                )}
            </Fragment>
        );
    }

    makeTable() {
        const { data, pagination, filters, hideSearch } = this.props;

        return (
            <div className="table player-list">
                <TimeZoneNote />
                <table>
                    <tbody>
                        <tr className={'table-options'}>
                            <td colSpan={players_headers.length - 4}>
                                {!hideSearch && (
                                    <TableSearch
                                        placeholder={'Search for players...'}
                                        onSearch={this.handleSearch}
                                    />
                                )}
                            </td>
                            <td colSpan={3}>
                                <FilterBadgeContainer
                                    filters={filters}
                                    removeFilter={this.handleRemoveFilter}
                                />
                            </td>
                            {/*<td>*/}
                            {/*todo: Commented out until table settings are implemented*/}
                            {/*<FilterButton onClick={() => {}}>*/}
                            {/*    <i className={'material-icons'}>*/}
                            {/*        view_list*/}
                            {/*    </i>*/}
                            {/*    <span>Table Settings</span>*/}
                            {/*</FilterButton>*/}
                            {/*</td>*/}
                            <td>
                                <FilterButton
                                    onClick={() =>
                                        this.modalInstance.openModal()
                                    }
                                >
                                    <i className={'material-icons'}>
                                        filter_list
                                    </i>
                                    <span>Filter</span>
                                </FilterButton>
                            </td>
                        </tr>
                        <tr className="headers">
                            {players_headers.map(header => (
                                <th key={header.key}>
                                    {header.value}
                                    {header.showArrowSort && (
                                        <Sorter
                                            sortingKey={header.key}
                                            currentSortingKey={
                                                this.props.currentSortingKey
                                            }
                                            onSort={this.handleSort}
                                        />
                                    )}
                                </th>
                            ))}
                        </tr>

                        {this.props.loading ? (
                            <tr>
                                <td colSpan={playerListColSpan}>
                                    <SpinLoader />
                                </td>
                            </tr>
                        ) : (
                            this.makeRows(data)
                        )}
                        <Pager
                            pagination={pagination}
                            onPaginationChanged={updatedPagination =>
                                this.props.onPaginationUpdated &&
                                this.props.onPaginationUpdated(
                                    updatedPagination
                                )
                            }
                            colspan={playerListColSpan}
                        />
                    </tbody>
                </table>
                <ModalContainer
                    title={'Filters'}
                    content={this.makeFilters()}
                    ref={this.modalRef}
                />
            </div>
        );
    }

    render() {
        return <div className={'player-list'}>{this.makeTable()}</div>;
    }
}
